import React from 'react';
import Hero from "../components/Hero";
import styles from "../styles/cookies.module.css";

export default function AvisoLegal() {
    return (
        <main>
            <Hero subtitle="AVISO LEGAL" />
        <section className={styles.contenido}>
        


            <h2>Datos identificativos</h2>
            <p>
                En cumplimiento con el deber de información estipulado en el artículo 10 de la Ley 34/2002 de Servicios de la Sociedad de la Información y del Comercio Electrónico, se informa que el sitio web <strong>Fisioterapia Global Esport i Salut</strong> es titularidad de:
            </p>
            <ul>
                <li><strong>Titular:</strong> Fisioterapia Global Esport i Salut</li>
                <li><strong>Domicilio:</strong> [Dirección física]</li>
                <li><strong>Email:</strong> info@globalsportisalut.com</li>
                <li><strong>Teléfono:</strong> 699 12 48 85</li>
            </ul>

            <h2>Objeto</h2>
            <p>
                El presente sitio web ha sido creado con la finalidad de informar y ofrecer los servicios de fisioterapia, así como facilitar el contacto entre los usuarios y la empresa.
            </p>

            <h2>Condiciones de uso</h2>
            <p>
                El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación plena de todas las condiciones incluidas en este Aviso Legal. El usuario se compromete a utilizar el sitio web de forma adecuada y conforme a la ley.
            </p>

            <h2>Propiedad intelectual e industrial</h2>
            <p>
                Todos los contenidos de este sitio web, incluyendo textos, imágenes, gráficos y diseño, son propiedad de Fisioterapia Global Esport i Salut o de sus licenciantes y están protegidos por la legislación sobre propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.
            </p>

            <h2>Responsabilidad</h2>
            <p>
                Fisioterapia Global Esport i Salut no se hace responsable de los errores u omisiones en los contenidos del sitio web ni de los daños derivados de su uso, ni de la actuación de usuarios mediante enlaces o contenidos de terceros.
            </p>

            <h2>Legislación aplicable</h2>
            <p>
                Este Aviso Legal se rige por la legislación española. Para cualquier controversia que pudiera derivarse del acceso o uso del sitio web, las partes se someten a los tribunales competentes de España.
            </p>
            </section>
            </main>
    );
}
